
ko.bindingHandlers.quill = {
    init: function (element, valueAccessor, allBindings, viewModel, context) {

        var toolbarOptions = [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['blockquote', 'code-block'],

            [{ 'header': 1 }, { 'header': 2 }],               // custom button values
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
            [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
            [{ 'direction': 'rtl' }],                         // text direction

            [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

            ['link', 'image', 'video', 'formula'],          // add's image support

            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
            [{ 'font': [] }],
            [{ 'align': [] }],

            ['clean']                                         // remove formatting button
        ];

        var q = new Quill(element, {
            modules: {
                toolbar: toolbarOptions
            },
            placeholder: 'Compose an epic...',
            theme: 'snow'
        });
        ko.utils.domData.set(element, 'quill', q);

        q.on('text-change', () => {
            console.log('TXTC', valueAccessor());
            valueAccessor()(q.root.innerHTML);
        });

        ko.utils
            .domNodeDisposal
            .addDisposeCallback(element, () => q.destroy());
    },
    update: function (element, valueAccessor, allBindings, viewModel, context) {
        var q = ko.utils.domData.get(element, 'quill');
        console.log('YXCVVXCVXVXYVXYVXYVXYV', valueAccessor());
        if (q.root.innerHTML !== ko.unwrap(valueAccessor())) {
            q.root.innerHTML = ko.unwrap(valueAccessor());
        }
    }
};